/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-be6b014c.mjs';
import { _ as _defineProperty } from '../../_chunks/dep-fa22eda7.mjs';
import { isVNode, defineComponent, toRefs, computed, createVNode, Fragment } from 'vue';
import { AddIcon, BrowseIcon, DeleteIcon, ErrorCircleFilledIcon } from 'tdesign-icons-vue-next';
import { Loading } from '../../loading/index.mjs';
import { useGlobalIcon } from '../../hooks/useGlobalIcon.mjs';
import { ImageViewer } from '../../image-viewer/index.mjs';
import { commonProps } from '../constants.mjs';
import { abridgeName } from '../../_common/js/upload/utils.mjs';
import '../../hooks/index.mjs';
import { Link } from '../../link/index.mjs';
import { Image } from '../../image/index.mjs';
import { useTNodeJSX } from '../../hooks/tnode.mjs';
import '../../_chunks/dep-558fadc3.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../loading/directive.mjs';
import '../../loading/plugin.mjs';
import '../../loading/loading.mjs';
import '../../_chunks/dep-1ec078b3.mjs';
import '../../loading/icon/gradient.mjs';
import '../../_common/js/loading/circle-adapter.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-b9505f3d.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-e9ff4ce8.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-61150968.mjs';
import '../../_chunks/dep-51567b45.mjs';
import '../../_chunks/dep-9a7888c7.mjs';
import '../../_chunks/dep-af8c0169.mjs';
import '../../hooks/useConfig.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-1f286011.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../_chunks/dep-4371fb57.mjs';
import '../../_chunks/dep-31d34e52.mjs';
import '../../_chunks/dep-67e8723b.mjs';
import '../../_chunks/dep-0bf03d55.mjs';
import '../../_chunks/dep-5b5daf08.mjs';
import '../../_chunks/dep-95049222.mjs';
import '../../_chunks/dep-ac19a2b6.mjs';
import '../../_chunks/dep-90d97bcb.mjs';
import '../../_chunks/dep-c8679a16.mjs';
import '../../_chunks/dep-939a74d6.mjs';
import '../../_chunks/dep-e4f65bc4.mjs';
import '../../_chunks/dep-45572c49.mjs';
import '../../_chunks/dep-1aa18f5f.mjs';
import '../../_chunks/dep-e09a06d8.mjs';
import '../../_chunks/dep-07f3660d.mjs';
import '../../_chunks/dep-0d3220b0.mjs';
import '../../_chunks/dep-895678a0.mjs';
import '../../_chunks/dep-b2bdc7b9.mjs';
import '../../_chunks/dep-0f45a6e0.mjs';
import '../../_chunks/dep-35a4fd8d.mjs';
import '../../_chunks/dep-54378e60.mjs';
import '../../_chunks/dep-25b8bf4b.mjs';
import '../../_chunks/dep-c40264c0.mjs';
import '../../_chunks/dep-9d499243.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-0927ceb7.mjs';
import '../../_chunks/dep-f0bd05df.mjs';
import '../../config-provider/type.mjs';
import '../../utils/dom.mjs';
import '../../utils/easing.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-55311368.mjs';
import '../../_chunks/dep-c25d13e7.mjs';
import '../../_chunks/dep-2a69909d.mjs';
import '../../_chunks/dep-c24f5c5d.mjs';
import '../../_chunks/dep-79d42d5d.mjs';
import '../../_chunks/dep-979d7716.mjs';
import '../../_chunks/dep-8b3be089.mjs';
import '../../_chunks/dep-84053b94.mjs';
import '../../_chunks/dep-398227bb.mjs';
import '../../loading/props.mjs';
import '../../hooks/useTeleport.mjs';
import '../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../loading/type.mjs';
import '../../image-viewer/image-viewer.mjs';
import '../../image-viewer/props.mjs';
import '../../image-viewer/base/ImageModalIcon.mjs';
import '../../image-viewer/base/ImageViewerUtils.mjs';
import '../../tooltip/index.mjs';
import '../../tooltip/tooltip.mjs';
import '../../_chunks/dep-ad4331e8.mjs';
import '../../_chunks/dep-16b9f817.mjs';
import '../../_chunks/dep-e40749a5.mjs';
import '../../_chunks/dep-437754aa.mjs';
import '../../_chunks/dep-6dbd6c24.mjs';
import '../../tooltip/props.mjs';
import '../../popup/props.mjs';
import '../../popup/index.mjs';
import '../../popup/popup.mjs';
import '@popperjs/core';
import '../../_chunks/dep-a861ee00.mjs';
import '../../_chunks/dep-3514a375.mjs';
import '../../hooks/useVModel.mjs';
import '../../popup/container.mjs';
import '../../hooks/useResizeObserver.mjs';
import '../../hooks/icon.mjs';
import '../../hooks/slot.mjs';
import '../../hooks/useCommonClassName.mjs';
import '../../hooks/useDefaultValue.mjs';
import '../../hooks/useDestroyOnClose.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../hooks/useRipple.mjs';
import '../../utils/set-style.mjs';
import '../../hooks/useVirtualScroll.mjs';
import '../../hooks/useImagePreviewUrl.mjs';
import '../../_common/js/log/log.mjs';
import '../../popup/type.mjs';
import '../../tooltip/util.mjs';
import '../../tooltip/type.mjs';
import '../../image-viewer/utils.mjs';
import '../../image-viewer/base/ImageItem.mjs';
import '../../image-viewer/hooks.mjs';
import '../../image-viewer/base/ImageViewerModal.mjs';
import '../../dialog/index.mjs';
import '../../dialog/dialog.mjs';
import '../../dialog/props.mjs';
import '../../dialog/hooks.mjs';
import '../../button/index.mjs';
import '../../button/button.mjs';
import '../../button/props.mjs';
import '../../hooks/useDisabled.mjs';
import '../../_chunks/dep-44e322cb.mjs';
import '../../button/type.mjs';
import '../../dialog/stack.mjs';
import '../../_common/js/utils/getScrollbarWidth.mjs';
import '../../dialog/type.mjs';
import '../../dialog/plugin.mjs';
import '../../image-viewer/const.mjs';
import '../../image/image.mjs';
import '../../_common/js/utils/observe.mjs';
import '../../image/props.mjs';
import '../../space/index.mjs';
import '../../space/space.mjs';
import '../../space/props.mjs';
import '../../space/type.mjs';
import '../../image/type.mjs';
import '../../image-viewer/type.mjs';
import '../../link/link.mjs';
import '../../form/hooks.mjs';
import '../../link/props.mjs';
import '../../link/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}
var ImageCard = defineComponent({
  name: "UploadImageCard",
  props: _objectSpread(_objectSpread({}, commonProps), {}, {
    multiple: Boolean,
    max: Number,
    disabled: Boolean,
    showUploadProgress: Boolean,
    triggerUpload: Function,
    uploadFiles: Function,
    cancelUpload: Function,
    onPreview: Function
  }),
  setup: function setup(props) {
    var _toRefs = toRefs(props),
      displayFiles = _toRefs.displayFiles,
      classPrefix = _toRefs.classPrefix,
      multiple = _toRefs.multiple,
      max = _toRefs.max;
    var locale = computed(function () {
      return props.locale;
    });
    var _useGlobalIcon = useGlobalIcon({
        AddIcon: AddIcon,
        BrowseIcon: BrowseIcon,
        DeleteIcon: DeleteIcon,
        ErrorCircleFilledIcon: ErrorCircleFilledIcon
      }),
      BrowseIcon$1 = _useGlobalIcon.BrowseIcon,
      DeleteIcon$1 = _useGlobalIcon.DeleteIcon,
      AddIcon$1 = _useGlobalIcon.AddIcon,
      ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon;
    var renderTNodeJSX = useTNodeJSX();
    var showTrigger = computed(function () {
      var _displayFiles$value;
      if (multiple.value) {
        return !max.value || displayFiles.value.length < max.value;
      }
      return !((_displayFiles$value = displayFiles.value) !== null && _displayFiles$value !== void 0 && _displayFiles$value[0]);
    });
    var renderMainContent = function renderMainContent(file, index) {
      return createVNode("div", {
        "class": "".concat(classPrefix.value, "-upload__card-content ").concat(classPrefix.value, "-upload__card-box")
      }, [createVNode(Image, {
        "class": "".concat(classPrefix.value, "-upload__card-image"),
        "src": file.url || file.raw,
        "error": ""
      }, null), createVNode("div", {
        "class": "".concat(classPrefix.value, "-upload__card-mask")
      }, [createVNode("span", {
        "class": "".concat(classPrefix.value, "-upload__card-mask-item"),
        "onClick": function onClick(e) {
          return e.stopPropagation();
        }
      }, [createVNode(ImageViewer, {
        "images": displayFiles.value.map(function (t) {
          return t.url;
        }),
        "defaultIndex": index,
        "trigger": function trigger(h, _ref) {
          var open = _ref.open;
          return createVNode(BrowseIcon$1, {
            "onClick": function onClick(_ref2) {
              var _props$onPreview;
              var e = _ref2.e;
              (_props$onPreview = props.onPreview) === null || _props$onPreview === void 0 ? void 0 : _props$onPreview.call(props, {
                file: file,
                index: index,
                e: e
              });
              open();
            }
          }, null);
        }
      }, null)]), !props.disabled && createVNode(Fragment, null, [createVNode("span", {
        "class": "".concat(classPrefix.value, "-upload__card-mask-item-divider")
      }, null), createVNode("span", {
        "class": "".concat(classPrefix.value, "-upload__card-mask-item"),
        "onClick": function onClick(e) {
          return e.stopPropagation();
        }
      }, [createVNode(DeleteIcon$1, {
        "onClick": function onClick(_ref3) {
          var _props$onRemove;
          var e = _ref3.e;
          return props === null || props === void 0 || (_props$onRemove = props.onRemove) === null || _props$onRemove === void 0 ? void 0 : _props$onRemove.call(props, {
            e: e,
            file: file,
            index: index
          });
        }
      }, null)])])])]);
    };
    var renderProgressFile = function renderProgressFile(file, loadCard) {
      var _locale$value;
      return createVNode("div", {
        "class": [loadCard, "".concat(classPrefix.value, "-upload__").concat(props.theme, "-").concat(file.status)]
      }, [createVNode(Loading, {
        "loading": true,
        "size": "medium"
      }, null), createVNode("p", null, [(_locale$value = locale.value) === null || _locale$value === void 0 || (_locale$value = _locale$value.progress) === null || _locale$value === void 0 ? void 0 : _locale$value.uploadingText, props.showUploadProgress ? " ".concat(file.percent, "%") : ""])]);
    };
    var renderFailFile = function renderFailFile(file, index, loadCard) {
      var _file$response, _locale$value2;
      return createVNode("div", {
        "class": loadCard
      }, [createVNode(ErrorCircleFilledIcon$1, null, null), createVNode("p", null, [((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.error) || ((_locale$value2 = locale.value) === null || _locale$value2 === void 0 || (_locale$value2 = _locale$value2.progress) === null || _locale$value2 === void 0 ? void 0 : _locale$value2.failText)]), createVNode("div", {
        "class": "".concat(classPrefix.value, "-upload__card-mask")
      }, [createVNode("span", {
        "class": "".concat(classPrefix.value, "-upload__card-mask-item"),
        "onClick": function onClick(e) {
          return e.stopPropagation();
        }
      }, [createVNode(DeleteIcon$1, {
        "onClick": function onClick(_ref4) {
          var _props$onRemove2;
          var e = _ref4.e;
          return props === null || props === void 0 || (_props$onRemove2 = props.onRemove) === null || _props$onRemove2 === void 0 ? void 0 : _props$onRemove2.call(props, {
            e: e,
            file: file,
            index: index
          });
        }
      }, null)])])]);
    };
    return function () {
      var _displayFiles$value2, _locale$value3;
      var customList = renderTNodeJSX("fileListDisplay", {
        params: {
          files: displayFiles.value
        }
      });
      if (customList) return customList;
      var cardItemClasses = "".concat(classPrefix.value, "-upload__card-item ").concat(classPrefix.value, "-is-background");
      return createVNode("div", null, [createVNode("ul", {
        "class": "".concat(classPrefix.value, "-upload__card")
      }, [(_displayFiles$value2 = displayFiles.value) === null || _displayFiles$value2 === void 0 ? void 0 : _displayFiles$value2.map(function (file, index) {
        var fileNameClassName = "".concat(classPrefix.value, "-upload__card-name");
        var loadCard = "".concat(classPrefix.value, "-upload__card-container ").concat(classPrefix.value, "-upload__card-box");
        var fileName = props.abridgeName ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(props.abridgeName))) : file.name;
        return createVNode("li", {
          "class": cardItemClasses,
          "key": index
        }, [file.status === "progress" && renderProgressFile(file, loadCard), file.status === "fail" && renderFailFile(file, index, loadCard), !["progress", "fail"].includes(file.status) && file.url && renderMainContent(file, index), fileName && (file.url ? createVNode(Link, {
          "href": file.url,
          "class": fileNameClassName,
          "target": "_blank",
          "hover": "color",
          "size": "small"
        }, _isSlot(fileName) ? fileName : {
          "default": function _default() {
            return [fileName];
          }
        }) : createVNode("span", {
          "class": fileNameClassName
        }, [fileName]))]);
      }), showTrigger.value && createVNode("li", {
        "class": cardItemClasses,
        "onClick": props.triggerUpload
      }, [createVNode("div", {
        "class": ["".concat(classPrefix.value, "-upload__image-add"), "".concat(classPrefix.value, "-upload__card-container"), "".concat(classPrefix.value, "-upload__card-box")]
      }, [createVNode(AddIcon$1, null, null), createVNode("p", {
        "class": "".concat(classPrefix.value, "-size-s")
      }, [(_locale$value3 = locale.value) === null || _locale$value3 === void 0 || (_locale$value3 = _locale$value3.triggerUploadText) === null || _locale$value3 === void 0 ? void 0 : _locale$value3.image])])])])]);
    };
  }
});

export { ImageCard as default };
//# sourceMappingURL=image-card.mjs.map
